import clarioslogo from "../assets/images/clarios-logo.png"

export default  function Header({ background, logo }: any) {

    const semIdentidade = (background === null && logo === null)

    return (
        <header className="certificado-header" style={{ backgroundColor: semIdentidade ? "#EDEDED" : background }}>
            <div className={"container"}>
                <figure className="img-responsive" >
                    <img src={ semIdentidade ? clarioslogo : logo} alt="Logo" style={{maxHeight: 127}} />
                </figure>
            </div>
        </header>
    )
}